export const ALLOWED_COMARR_COMPANY_IDS = new Set([1, 141, 144]);
export const ALLOWED_TRANSPOREON_COMPANY_IDS = new Set([1]); // , 162
